<template>
  <v-radio v-bind="$attrs" v-on="$listeners">
    <!-- Pass on all named slots -->
    <slot v-for="slot in Object.keys($slots)" :name="slot" :slot="slot" />

    <!-- Pass on all scoped slots -->
    <template
      v-for="slot in Object.keys($scopedSlots)"
      :slot="slot"
      slot-scope="scope"
      ><slot :name="slot" v-bind="scope"
    /></template>
  </v-radio>
</template>

<script>
export default {
  name: "ARadio",
};
</script>

<style scoped>
.v-radio {
  font-family: 'Noto Sans JP' !important;
}
::v-deep .primary--text {
  color: var(--v-neutralGray-base) !important;
}
</style>